import React from 'react'
import compose from 'recompose/compose'
import _ from 'lodash'
import {withI18n} from '../../hocs'
import * as S from './styled'
import ActionDialog from '../action-dialog'
import {InputEditor, InputField} from '../../atoms'
import {SimpleDialog} from '../../molecules'
import * as api from '../../../api'
import {MODULES} from "../../../config/constants";

const ModalMailCustom = ({ open, handleClose, i18n, onSubmit, subjectDefault, messageDefault }) => {
  const [openPopup, setOpenPopup] = React.useState(false)
  const [subject, setSubject] = React.useState(subjectDefault || '')
  const [message, setMessage] = React.useState(messageDefault || '')

  const [defaultMessages, setDefaultMessages] = React.useState([])

  React.useEffect(() => {
    const fetchData = async () => {
      const result = await api.getDefaultMessages(MODULES.ID_EMPLOYEE_LINE)
      setDefaultMessages(result)
    }
    fetchData()
  }, [])

  function handleClickOpenPopup() {
    setOpenPopup(true)
  }

  const handleClosePopup = value => {
    setOpenPopup(false)

    if (value) {
      const subject = value.subject || ''
      const body = value.body || ''

      setSubject(subject)
      setMessage(body)
    }
  }

  const clear = () => {
    setSubject('')
    setMessage('')
  }

  const handleSubmit = e => {
    e.preventDefault()

    // El modal se cierra cuando la petición del padre ha ido bien; si falla sigue abierto
    return Promise.resolve(onSubmit({
      subject,
      message
    })).then(() => {
      handleClose()
      clear()
    })
  }

  const submitDisabled = _.isEmpty(subject) || _.isEmpty(message)
  // Con el envío deshabilitado, Enter en el asunto no debe mandar nada (antes lo frenaba el submit disabled)
  const handleFormSubmit = e => {
    e.preventDefault()
    !submitDisabled && handleSubmit(e).catch(() => {})
  }

  return (
    <>
      <ActionDialog
        open={open}
        title={i18n.modalMailCustom.quoteCall}
        onClose={handleClose}
        onConfirm={handleSubmit}
        cancelLabel={i18n.dialog.decline}
        confirmLabel={i18n.modalMailCustom.send}
        confirmDisabled={submitDisabled}
        disableBackdropClose
        maxWidth="md"
      >
        <S.Form onSubmit={handleFormSubmit}>
          <div>
            <S.Label>{i18n.modalMailCustom.subject}</S.Label>
            <InputField
              fontSize="small"
              placeholder={i18n.modalMailCustom.writeSubject}
              name="subject"
              value={subject}
              handleOnChange={value => setSubject(value)}
            />
          </div>
          <div>
            <S.Label>{i18n.modalMailCustom.message}</S.Label>
            <InputEditor
              fontSize="small"
              placeholder={i18n.modalMailCustom.writeMessage}
              name="message"
              value={message}
              onChange={value => setMessage(value)}
            />
          </div>
          <S.LinkButton type="button" onClick={handleClickOpenPopup}>{i18n.modalMailCustom.defaultMessages}</S.LinkButton>
        </S.Form>
      </ActionDialog>
      <SimpleDialog defaultMessages={defaultMessages} open={openPopup} onClose={handleClosePopup} />
    </>
  )
}

const enharce = compose(withI18n)

export default enharce(ModalMailCustom)
